import React from "react";
import Images from "../../../asset/Images";

const QuotationHeader = ({ content }) => {
  const normalizedContent = (content || "").toLowerCase().trim();

  const isSriLakshmiBuildCraft =
    normalizedContent === "sri lakshmi build craft" ||
    normalizedContent === "Sri Lakshmi Build Craft" ||
    normalizedContent === "SRI LAKSHMI BUILD CRAFT";
  return (
    <div className="quotation_logo_block">
      {isSriLakshmiBuildCraft ? (
        <img
          src={Images?.logo11}
          alt="no-image"
          style={{ width: "100%", height: "100%", objectFit: "fill" }}
        />
      ) : (
        <img
          src={Images?.rasispacegreen}
          alt="no-image"
          style={{ width: "100%", height: "100%", objectFit: "fill" }}
        />
      )}
    </div>
  );
};

export default QuotationHeader;
